/* eslint-disable */
export default {
  // actions
  actions: {
    addDamage: 'Ajouter',
    login: 'Login',
    select: 'Sélectionner',
    clear: 'Nettoyer',
    continue: 'Continuer',
    cancel: 'Annuler',
    import: 'Importer',
    export: 'Exporter',
    exportAll: 'Exporter tout',
    selectFile: 'Sélectionnez le fichier',
    search: 'Rechercher',
    save: 'Sauvegarder',
    delete: 'Éliminer'
  },
  downloadModal: {
    title: 'Téléchargement du fichier',
    text:
      'Le téléchargement du fichier peut prendre plusieurs minutes, veuillez ne pas quitter la page.'
  },
  // component: furniture
  furniture: {
    title: 'Mobilier',
    empty: {
      short: 'Référence sinistre manquante',
      long:
        'Pour pouvoir ajouter des dommages mobiliers, entrez la référence du sinistre'
    },
    kindOfProperty: 'Type de propiété',
    kindOfPropertyOptions: {
      owner: 'Propriétaire',
      renter: 'Locataire'
    }
  },
  // component: warrantyLayout
  warrantyLayout: {
    registerSinister: 'Enregister le sinistre',
    newSinister: 'Nouveau sinistre',
    registeredDamages:
      '0 x Dommage enregistré | 1 x Dommage enregistré | {count} x Dommages enregistrés',
    modals: {
      newSinister: {
        title: 'Nouveau sinistre. Êtes-vous sûr?',
        body: 'Toutes les données seront restaurées'
      }
    }
  },
  damageTypeCpi: {
    calendarLabel: {
      literal: "Date d'achat"
    },
    priceDamage: {
      literal: "Prix d'achat"
    }
  },
  // component: warrantyRef
  warrantyRef: {
    sinisterRef: {
      literal: 'Référence du sinistre'
    },
    secondaryRef: {
      literal: 'Référence secondaire (optionnel)'
    }
  },
  // component: warrantyProps
  warrantyProps: {
    aboutProperty: 'Informations complémentaires',
    address: {
      literal: 'Adresse',
      placeholder: 'Entrer un lieu'
    },
    zipCode: {
      literal: 'Code postal'
    },
    propertyType: {
      literal: 'Type de propriété',
      options: {
        appartment: 'Appartement',
        maison: 'Maison',
        local_commercial: 'Local commercial'
      }
    },
    residentType: {
      literal: 'Type de résident',
      options: {
        propietarie: 'Propriétaire',
        locataire: 'Locataire',
        propietarie_non_occupant: 'Propriétaire Non Occupant'
      }
    },
    moreThanTwoYears: {
      literal: "Age de l'immeuble",
      options: {
        less: 'Moins de 2 ans',
        more: 'Plus de 2 ans'
      }
    },
    map: {
      empty: {
        title: 'Sans adresse',
        text: 'Veuillez saisir une adresse valide'
      }
    },
    nameApplicant: {
      literal: `Nom de l'assuré`,
      placeholder: 'Entrez le nom'
    },
    formsList: 'Formulaires',
    fnolIdsList: 'Contrat',
    userIdsList: "Type d'utilisateur",
    buttonLink: {
      literal: 'Voir le lien utilisateur'
    },
    modalLink: {
      buttonGenerateLink: 'Générer un lien',
      buttonCancel: 'Annuler',
      title: 'Lien utilisateur',
      alertMessage: 'Les Informations complémentaires doivent étre complétées.',
      alertAction: 'Compléter les informations complémentaires'
    },
    moreInfoModal: {
      buttonGenerateLink: 'Informations complémentaires',
      buttonCancel: 'Annuler',
      title: 'Informations complémentaires',
      send: 'Envoyer et voir le lien utilisateur',
      sendOk:
        'Les informations du formulaire ont bien été enregistrées et envoyées',
      sendError:
        'Une erreur s’est produite et le formulaire ne peut être enregistré',
      personalInfo: {
        title: '1. Données personnelles',
        name: 'Nom',
        surname: 'Prénom',
        phone: 'Téléphone',
        email: 'E-mail',
        sinisterAddress:
          'L’adresse du contrat est-elle la même que celle du sinistre ?'
      },
      contractInfo: {
        date: 'Date du sinistre',
        police: 'Nº Police',
        title: '2. Contrat',
        isValid: 'Le contrat est-il valide?',
        franchiseGenerale: 'Franchise générale',
        franchiseInondation:
          'Franchise inondation\nNe cocher que dans le cas où l’option est souscrite',
        franchiseEgout:
          'Franchise Égout / Eaux de ruissellement\nNe cocher que dans le cas où l’option est souscrite',
        deductibles: 'Biens immobiliers déductibles (€)',
        allowance: 'Allocation pour embellissement (€)',
        furnitureAllowance: 'Indemnité de mobilier (€)',
        options: 'Options',
        franchiseMontantLibre: 'Franchise montant libre',
        swimmingPool: 'Piscine',
        externalFittings: 'Installations extérieures',
        ran: 'Remplacement à neuf'
      },
      verifications: {
        title: '3. Vérifications',
        beforeSinister: 'Absence de doublon',
        beforeSinisterTooltip:
          'Absence de sinistre en cours à la même adresse et avec la même couverture, survenu dans les 15 jours précédant ou suivant ce sinistre.',
        litigationAlertAbsence: 'Absence d’alerte contentieux',
        indemnityName: 'Nom d’indemnisation au cours de l’année civile',
        GaG: 'Gré à gré',
        ren: 'Réparation en nature'
      },
      sinisterCause: {
        title: '4. Cause du sinistre',
        cause: 'Quelle est la cause du sinistre',
        sinisterPlace: 'Où se situe l’origine du sinistre ? ',
        damagePlace: 'Où se situent les dégâts ?',
        causeRepaired: 'La cause est-elle réparée ? ',
        thirdPartyInvolved:
          'Y a-t-il un tiers identifié impliqué dans le sinistre ?'
      },
      modalInformation: {
        title: 'Informations manquantes',
        literal: 'Pour créer un lien, vous devez d\'abord remplir les Informations complémentaires.',
        literal2: 'Merci de compléter cette section avant de continuer.',
        cancel: 'Annuler',
        completeInformation: 'Compléter les infos',
      }
    },
    optionsUserType: {
      insured: 'Selfcare générique',
      professional: 'Selfcare BillMA Professionnel',
      billma_insured: 'Selfcare BillMA Assuré',
      billma_agent: 'Selfcare Agent',
      billma_user: 'Selfcare BillMA',
      ren_professional: 'Selfcare Ren Professionnel',
      ren_insured: 'Selfcare Ren Assuré'
    },
    clientPhoneNumber: 'Numéro de téléphone',
    clientEmail: 'Email',
    clientValidationType: 'Type de validation',
    countryCode: 'Préfixe',
    example: 'Exemple: ',
    requiredFields: {
      title: 'Champs obligatoires',
      body: 'Champs obligatoires non renseignés'
    }
  },
  // component: warrantySticky
  warrantySticky: {
    analyze: 'Analyser',
    generateReport: 'Générer un rapport',
    generateReportFnol: 'Description dommages',
    materialListBtn: 'Liste du matériel',
    smartReport: 'Rapport Smart',
    damageSummary: {
      title: 'Valorisation des biens',
      tableHead: {
        damages: 'Dommages',
        greAGre: 'Gré à gré',
        reparationNetwork: 'Réparation réseau agrée',
        reparationExcept: 'Réparation hors réseau'
      },
      tableSubHead: {
        embellishments: 'Embellisement',
        immobilier: 'Immobilier',
        mobilier: 'Mobilier'
      },
      tableMain: {
        manpowerHours: 'MO (heures)',
        manpowerCost: 'MO (euros)',
        materialCost: 'Matériel',
        totalCost: 'Total',
        priceWithoutTaxes: 'HT',
        priceWithTaxes: 'TTC'
      },
      description: {
        quantity: 'Quantité'
      }
    },
    damageCounters: {
      gag: 'Gré a gré',
      materials: 'Matériaux et fourniture',
      estimatedTime: 'Temps estimé',
      authorizedNetworkRepair: 'Réparation réseau agrée',
      artessianRepair: 'Réparation hors réseau',
      immediate: 'Immédiat',
      difference: 'Différé',
      ensembleImage: "Photo d'ensemble",
      presImage: 'Photo de près',
      totalPrice: 'Prix total'
    },
    manPower: {
      title: "Changement des prix de main d'oeuvre",
      calculatePrice: 'Calculer prix',
      cancel: 'Annuler',
      setPrice: 'Fixer les prix'
    },
    materialList: {
      title: "Matériaux et main d'oeuvre",
      manpowerTime: "Main d'oeuvre (heures)",
      manpowerPrice: "Main d'oeuvre (€)",
      manpowerTitle: "Prix de main d'oeuvre",
      materials: 'Matériaux',
      gag: 'Indemnización Gré à gré',
      downloadPDF: 'Télécharger PDF',
      cancel: 'Annuler',
      send: 'Envoyer'
    }
  },
  // component: login
  login: {
    title: 'Mes dommages',
    titleMA: 'MAValue',
    text: 'Votre outil de valorisation des sinistres',
    authenticationError: "Erreur d'authentification",
    authenticationBlock: 'Login bloqué, essayez-le après quelques minutes',
    authenticationOk: 'Login correct',
    sso_processing: 'Vérification de l’identité en cours...',
    sso_wait: 'Veuillez patienter un instant.',
    sso_error_title: 'Erreur d’authentification',
    sso_error_msg: 'Une erreur est survenue lors de la connexion via SSO. Veuillez réessayer ou contacter votre administrateur.',
    inputs: {
      username: "Nom d'utilisateur",
      password: 'Mot de passe'
    },
    login: 'Login'
  },
  // component: error
  error: {
    title: 'Mes Dommages',
    titleMA: 'MAValue',
    text: "La page que vous recherchez n'existe pas",
    btn: 'Revenir'
  },
  // component: adminLayout
  adminLayout: {
    modals: {
      import: {
        title: 'Importer paramètres',
        description:
          "Pour ajouter ou mdifier des paramètres veuillez importer un fichier. Si le paramètre n'existe pas il sera créé ou modifier en cas contraire."
      },
      export: {
        title: 'Exporter paramètres',
        description: 'Veuillez choisir les champs à filtrer.'
      }
    },
    filters: {
      warranty: 'Groupe de garantie',
      subwarranty: 'Sous-groupe de garantie'
    },
    notifications: {
      importedFile: {
        title: 'Fichier importé',
        body: 'La table sera chargée.'
      }
    }
  },
  // component: parameters (gagadmin)
  gagParameters: {
    title: 'Paramètres',
    table: {
      paramName: 'Nom du paramètre',
      paramValue: 'Valeur du paramètre',
      customizable: 'Éditable'
    }
  },
  // component: repMat (gagadmin)
  gagRepMat: {
    title: 'Matériaux de réparation',
    table: {
      rep_type_code: 'Code',
      rep_description: 'Description',
      rep_mat: 'Matériel',
      mat_format_sale: 'Format de vente',
      dam_measure_unit: 'Unité de mesure',
      conv_unit_per_mat_measure: 'Unité de conversion par mesure de matériau',
      mat_unit_price: 'Prix',
      is_hours: 'Seulement des heures',
      image: 'Image'
    }
  },
  // component: zipCode (gagadmin)
  gagZipCode: {
    title: 'Codes postaux',
    table: {
      dept_code: 'Code',
      zip_code_min: 'Code postal minimum',
      zip_code_max: 'Code postal maximum',
      country: 'Pays',
      clean_cost: 'Coût',
      displacement_hours: 'Heures de déplacement',
      coef: '*** coef',
      factmin: '*** factmin'
    }
  },
  // component: ajustage (gagadmin)
  gagAjustage: {
    title: "Ajuster en fonction de l'âge du client",
    table: {
      interval_age_start: 'Âge minimum',
      interval_age_end: 'Âge maximum',
      age_coef: 'Coefficient'
    }
  },
  // component: userLimits (gagadmin)
  gagUserLimits: {
    title: 'Limites',
    table: {
      user: 'Utilisateur',
      hour_price_max_limit: 'Prix​/heure max.',
      hour_price_min_limit: 'Prix​/heure min.'
    }
  },
  // component: salaries (gagadmin)
  gagSalaries: {
    title: 'Les salaires',
    table: {
      zip_code: 'Code postal',
      csp: '*** csp',
      salary_hour: 'Prix​​/heure'
    }
  },
  // component: parameters (admin)
  parameters: {
    title: 'Paramètres',
    table: {
      paramName: 'Nom de paramètre',
      paramValue: 'Valeur du paramètre',
      customizable: 'Editable',
      type: 'Tipo'
    }
  },
  // component: reparations (admin)
  reparations: {
    title: 'Réparation',
    warrantyid: 'Groupe de garantie',
    subcategory: 'Sous-catégorie',
    table: {
      repTypeCode: 'Code de réparation',
      description: 'Description',
      type: 'Tipo de réparation',
      surfaceUnit: 'Unité de mesure',
      damagesType: 'Tipo de daño',
      priceCalcForm: 'Prix cálculo formulario'
    }
  },
  // component: coefficients (admin)
  coefficients: {
    title: 'Coeficientes',
    table: {
      repCodeType: 'Code de réparation',
      description: 'Description',
      matSRen: 'Mat_s_REN',
      coefMat: 'Coef_mat',
      coefMo: 'Coef_mo',
      price: 'Prix'
    }
  },
  // component: depreciations (admin)
  depreciations: {
    title: 'Vétusté',
    table: {
      repTypeCode: 'Code de réparation',
      description: 'Description',
      years: 'Años',
      depreciationPerc: 'Porcentaje de réparation'
    }
  },
  // component: transversalCosts
  transversalcosts: {
    title: 'Actions complémentaires',
    table: {
      damageType: 'Type de dommage',
      componentName: 'Nom du composant',
      description: 'Description',
      costFormat: 'Coût du format',
      value: 'Valor'
    }
  },
  // component: users
  users: {
    title: 'Utilisateurs',
    newUser: 'Nouvel utilisateur',
    table: {
      username: "Nom d'utilisateur",
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'E-mail',
      role: 'Rôle',
      company: 'Compagnie'
    },
    modals: {
      newUser: {
        title: 'Nouvel utilisateur'
      },
      editUser: {
        title: "Modifier l'utilisateur"
      },
      deleteUser: {
        title: 'Vous supprimerez cet utilisateur.',
        body: 'Cette action est irréversible. Voulez-vous continuer?'
      },
      user: {
        fields: {
          firstName: 'Prénom',
          lastName: 'Nom',
          username: "Nom d'utilisateur",
          email: 'Email',
          company: "Nom d'compagnie",
          role: 'Rôle utilisateur',
          password: 'Mot de passe',
          repeatPassword: 'Répéter le mot de passe'
        }
      }
    },
    filters: {
      company: 'Filtrer par compagnie',
      role: 'Filtrer par rôle'
    }
  },
  // component: forms
  adminForms: {
    filterLabel: 'Filtrer par formulaire',
    import: {
      title: 'Importer paramètres',
      description:
        "Pour ajouter ou mdifier des paramètres veuillez importer un fichier. Si le paramètre n'existe pas il sera créé ou modifier en cas contraire."
    },
    export: {
      title: 'Exporter paramètres',
      description:
        'Pour ajouter ou modifier des paramètres, exporter un fichier puis le réimporter.'
    },
    toast: {
      success: 'Le fichier a été traité avec succès',
      error: "Le fichier n'a pas pu être traité"
    },
    modal: {
      title: 'Document en cours de traitement',
      description:
        "Ce processus peut durer quelques minutes. Veuillez ne pas fermer l'application"
    }
  },
  // component: small device modal
  smDevModal: {
    title: "Résolution d'écran invalide",
    text:
      "Le contenu que vous souhaitez voir n'est pas disponible pour la résolution de votre écran. Veuillez réessayer à partir d'un appareil dont la résolution est supérieure à 1024 pixels."
  },
  // notification
  notifications: {
    error: {
      0: {
        title: 'Erreur',
        body: "Erreur durant l'action"
      },
      400: {
        title: 'Champ obligatoire non renseigné',
        body: 'Veuillez réviser les champs non renseignés'
      },
      500: {
        title: 'Erreur',
        body: 'Erreur générique'
      },
      409: {
        title: "Erreur d'identification",
        body: 'Le sinistre existe déjà'
      },
      title: 'Erreur',
      body: "Erreur durant l'action"
    },
    addDamage: {
      title: 'Dommage créé',
      body: "Le dommage s'est créé correctement"
    },
    newSinister: {
      title: 'Nouveau sinistre',
      body: "L'identifiant du sinistre a été modifié"
    },
    deleteDamage: {
      title: 'Dommage éliminé',
      body: 'Le dommage a été éliminé correctement'
    },
    pdfDamages: {
      title: 'Rapport créé',
      body: 'Rapport créé correctement'
    },
    pdfMaterial: {
      title: 'Rapport créé',
      body: 'Rapport créé correctement'
    },
    mailPdfMaterial: {
      title: 'Courriel envoyé',
      body: 'Courriel envoyé correctement',
      error: {
        title: 'Courriel non valide',
        body: 'Veuillez saisir un courriel correct'
      }
    },
    moCalculation: {
      title: 'Prix mis à jour',
      body: 'Rechargement du rapport en cours'
    },
    changeLanguage: {
      title: 'Changement de langue',
      body: 'Renvoi'
    },
    loadSinisterOK: {
      title: 'Sinistre chargé',
      body: 'Mise à jour des informations'
    },
    loadSinisterKO: {
      title: 'Erreur sinistre',
      body: 'Erreur lors du chargement de la perte'
    },
    paramChanged: {
      title: 'Paramètre modifié',
      body: 'La table se mettra à jour automatiquement.'
    },
    user: {
      isRequired: {
        title: 'Champs manquants',
        body: 'Veuillez remplir tous les champs correctement'
      },
      isEmail: {
        title: 'Courriel incorrect',
        body: `L'e-mail entré n'est pas valide`
      },
      isSamePassword: {
        title: 'Répéter le mot de passe',
        body: 'Les mots de passe ne correspondent pas'
      },
      createdUser: {
        title: 'Utilisateur créé',
        body: `Vue en cours d'actualisation`
      },
      modifiedUser: {
        title: 'Utilisateur modifié',
        body: `Vue en cours d'actualisation`
      },
      deletedUser: {
        title: 'Utilisateur supprimé',
        body: `Vue en cours d'actualisation`
      },
      error: {
        400: {
          title: 'Champs manquants',
          body: 'Vérifiez les champs du formulaire'
        },
        500: {
          title: 'Error',
          body: `Une erreur s'est produite`
        },
        409: {
          title: `Erreur d'identification`,
          body: `L'utilisateur existe déjà`
        }
      }
    }
  },

  // charts view
  charts: {
    mapTitle: 'Sinistres par localité',
    sinisterEvolutionTitle: 'Evaluations et coûts moyens réalisés par mois',
    tableTitle: 'Tableau de données',
    noDataAvailable: 'Pas de données disponibles',
    barChartDamageSubType: 'Coût moyen du type de garantie',
    barChartDamageType: 'Coût moyen du type de dommages',
    barChartCompensationType: "Coût par type d'indemnisation",
    pieChart: 'Répartition par sous-type de dommages',
    titleView: 'Tableau de bord',
    downloadData: 'Téléchargez données',
    fromDate: 'De',
    toDate: 'À',
    hintFromDate: "Veuillez sélectionner le 'partir de la date'",
    hintToDate: "Veuillez sélectionner le 'à ce jour'",
    tableHeadTitle: {
      company: 'Compagnie',
      userName: "Nom d'utilisateur",
      l1: 'Niveau 1',
      l2: 'Niveau 2',
      l3: 'Niveau 3',
      l4: 'Niveau 4',
      q: 'q',
      averageCost: 'Coût moyen',
      total: 'Total'
    },
    bubbleChartLegend: {
      price: 'Montant',
      damagesCount: 'Fréquence'
    }
  },

  // search view
  search: {
    secondaryRef: 'Référence secondaire',
    status: 'Statut',
    gag: 'GAG',
    ren: 'REN',
    asp: 'ASP',
    createdDate: 'Date de création',
    updatedDate: 'Date de mise à jour'
  },

  // tutorials view
  tutorials: {
    title: 'Tutoriels',
    subtitle: 'Tutoriel'
  },

  // Biens obiliers View
  biensMobiliers: {
    title: 'Biens mobiliers',
    searchEmpty: {
      search: 'Votre recherche',
      notFound: "n'a pas obtenu de résultats"
    },
    text:
      "Utilisez le moteur de recherche ou parcourez le menu latéral pour trouver l'article que vous recherchez. Vous pouvez également choisir parmi nos catégories les plus fréquentes"
  },

  // dashboard view
  dashboard: {
    GAG: {
      title: 'Gag et télévaluations réalisées',
      downloadData: 'Télécharger données',
      filters: {
        date: 'Période',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        orderBy: 'Trier par',
        orderByOptions: {
          tmo: 'TMO',
          totalGAG: 'Total GAG',
          sinisterTotal: 'Total televal',
          conversion: 'Conversion'
        }
      },
      kpis: {
        gag: 'GAG réalisés',
        TE: 'Télévals effectuées',
        gagWeek: 'Gest avec 1 GAG/sem',
        gagSans: 'Gest sans GAG'
      },
      table: {
        headers: {
          manager: 'Gestionnaire',
          conversion: 'Conversion',
          weeks: 'Semaines',
          evolution: 'Evolution',
          total: 'Totaux',
          totalGAG: 'Total GAG',
          totalTE: 'Total televal',
          TMO: 'TMO'
        }
      }
    }
  },

  // common
  common: {
    surface: 'Surface',
    line: 'Ligne',
    distance: 'Distance',
    actualCalc: 'Calcul en cours',
    selectOnTheMap: 'Sélectionnez sur la carte pour mesurer',
    mapAction: 'Mesurer la carte',
    mapActionLine: 'Mesurer la carte',
    min: 'Minimum',
    max: 'Maximum',
    total: 'Total',
    recommended: 'Recommandé',
    standard: 'Standard',
    noFile: 'Aucun fichier sélectionné',
    email: 'Courrier électronique',
    search: 'Recherche',
    results: 'Résultats',
    noresults: {
      short: 'Aucun résultat',
      long: "Il n'y a pas de résultats pour votre recherche"
    },
    true: 'Oui',
    false: 'Non',
    noOptions: 'Sans option',
    noSelected: 'Aucun sélectionné.',
    agentView: 'vue agent',
    managerView: 'vue gestionnaire',
    unit: '0 unités | x {count} unité | x {count} unités'
  },
  empties: {
    noResults: {
      title: 'Sans résultat.',
      descr: "Veuillez choisir d'autres paramètres de recherche."
    }
  },
  // Area component
  areaMeasurement: {
    damageArea: 'Zone de dommages',
    measurementTipe: 'En mètres carrés',
    heightMeasurement: 'Hauteur',
    widhtMeasurement: 'Largeur'
  }
}
